import type { BomEvent } from "@/lib/bom";

export interface BomEventsTimelineProps {
  events: BomEvent[];
}

function formatWhen(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString();
}

export function BomEventsTimeline({ events }: BomEventsTimelineProps) {
  if (events.length === 0) {
    return <p className="text-sm text-muted-foreground">No events recorded for this BOM.</p>;
  }
  return (
    <ol className="space-y-3" aria-label="BOM events">
      {events.map((e) => (
        <li key={e.bomEventId} className="border-l-2 border-border pl-3">
          <p className="text-sm">{e.description}</p>
          <p className="text-xs text-muted-foreground">
            {formatWhen(e.createdOn)}
            {e.createdByName ? ` · ${e.createdByName}` : ""}
          </p>
        </li>
      ))}
    </ol>
  );
}
